<template>
  <div :id="id + '_wrapper'" >
  
     <multiselect
      ref="multiselect"
      :id="id"
      v-model="selectedObjects"
      :track-by="trackBy"
      label="name"
      :options="items"
      :multiple="multiple"
      :placeholder="placeholder"
      selectLabel
      selectedLabel
      deselectLabel
      openDirection="bottom"
      :searchable="searchable"
      :closeOnSelect="multiple ? false : true"
      :allowEmpty="allowEmpty"
      @input="onSelected"
      :aria-labelledby="id+'_label'"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <slot name="singleLabel" :option="option">
          <strong>{{ option.name }}</strong>
        </slot>
      </template>
      <template slot="option" slot-scope="{ option }">
        <slot name="option" :option="option">{{option.name}}</slot>
      </template>
    </multiselect>
  </div>
</template>

<script>

import Multiselect from "@/components/ic-common/form/3rdparty/vuemultiselect-modified";
import { has } from "lodash";

export default {
  name: "IcSelect",
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "..."
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    searchable: {
      type: Boolean,
      default: true
    },    
    v: {
      type: Object
    },
    forceSingleSelect: {
      type: Array,
      default: () => ["na"]
    },
    trackBy: {
      type: String,
      default: "value"
    },
    asObject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      selectedObjects: [],
      fields : { text: 'name', value: 'value' }
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      this.selectedObjects = this.valuesToObjects(newValue);
    },
    values: function(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.items = newValue;
        this.selectedObjects = this.valuesToObjects(this.value);
      }
    }
  },
  beforeMount() {
    this.items = this.prepareValues(this.values);
    
    window.addEventListener("hashchange", this.checkHash);    

  },
  beforeDestroy() {
    window.removeEventListener("hashchange", this.checkHash); // Czyszczenie nasłuchiwania
  },  
  mounted() {
    Array.prototype.push.apply(this.selectedObjects,this.valuesToObjects(this.value));
    this.checkHash(); // Wywołanie przy załadowaniu komponentu
  },
  methods: {
    checkHash() {
      const hash = window.location.hash.slice(1); // Pobierz wartość po #
      const matchingItem = this.items.find(item => item.value === hash); // Znajdź obiekt z pasującą wartością
      if (matchingItem && !this.selectedObjects.includes(matchingItem)) {
        this.$refs.multiselect.select(matchingItem);
        
        // if(this.multiple)
        //   this.selectedObjects.push(matchingItem); // Dodaj obiekt do selectedItems, jeśli jeszcze nie istnieje
        // else
        //   this.selectedObjects=matchingItem;
        
      }
    },    
    onSelected(value, id) {
     
      let values = null;
      if (this.multiple) {
        let isNA = this.value.filter(
          item => this.forceSingleSelect.indexOf(item) > -1
        );
        let selectedNA = this.selectedObjects.filter(
          item => this.forceSingleSelect.indexOf(item[this.trackBy]) > -1
        );

        if (!isNA.length && selectedNA.length && this.value.length > 0) {
          this.selectedObjects = this.selectedObjects.filter(
            item => this.forceSingleSelect.indexOf(item[this.trackBy]) > -1
          );
        } else if (isNA.length) {
          this.selectedObjects = this.selectedObjects.filter(
            item => this.forceSingleSelect.indexOf(item[this.trackBy]) == -1
          );
        }

        values = [];
        this.selectedObjects.forEach(item => {
          if (this.asObject) {
            values.push(item);
          } else {
            values.push(item[this.trackBy]);
          }
        });
      } else {
        if (this.selectedObjects) {
          values = this.asObject
            ? this.selectedObjects
            : this.selectedObjects[this.trackBy];
        }
      }
      
      
      this.$emit("input", values);
      this.$emit("update:select", this.selectedObjects);
      if (this.v) {
        this.v.$touch();
      }
    },
    valuesToObjects(values) {
      let newValues = null;
      if (this.multiple) {
        newValues = this.items.filter(item => {
          return values.indexOf(item[this.trackBy]) != -1;
        });
      } else {
        newValues = this.items.find(item => {
          return values === item[this.trackBy];
        });
      }
      return newValues;
    },
    prepareValues(values) {
      if (values && values.length) {
        let val = [];
        values.forEach(item => {
          if (typeof item !== "object") {
            val.push({ value: item, label: item, name: item });
          } else {
            item.label = item.name;
            val.push(item);
          }
        });
        ////console.log(val);
        return val;
      }
    }
  },
  components: {
    Multiselect,
  }
};
</script>

<style lang="scss">

fieldset[disabled] .multiselect {
  pointer-events: none;
}
.multiselect__spinner {
  position: absolute;
  right: 1px;
  top: 1px;
  width: 48px;
  height: 35px;
  background: #fff;
  display: block;
}
.multiselect__spinner:before,
.multiselect__spinner:after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -8px 0 0 -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border-color: #41b883 transparent transparent;
  border-style: solid;
  border-width: 2px;
  box-shadow: 0 0 0 1px transparent;
}
.multiselect__spinner:before {
  animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
  animation-iteration-count: infinite;
}
.multiselect__spinner:after {
  animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);
  animation-iteration-count: infinite;
}
.multiselect__loading-enter-active,
.multiselect__loading-leave-active {
  transition: opacity 0.4s ease-in-out;
  opacity: 1;
}
.multiselect__loading-enter,
.multiselect__loading-leave-active {
  opacity: 0;
}
.multiselect,
.multiselect__input,
.multiselect__single {
  font-family: inherit;
  font-size: 16px;
  touch-action: manipulation;
}
.multiselect {
  box-sizing: content-box;
  display: block;
  position: relative;
  width: 100%;
  min-height: 50px;
  text-align: left;
  color: #35495e;
}
.multiselect * {
  box-sizing: border-box;
}
.multiselect:focus {
  outline: none;
}
.multiselect--disabled {
  background: #ededed;
  pointer-events: none;
  opacity: 0.6;
}
.multiselect--active {
  z-index: 50;
}
.multiselect--active:not(.multiselect--above) .multiselect__current,
.multiselect--active:not(.multiselect--above) .multiselect__input,
.multiselect--active:not(.multiselect--above) .multiselect__tags {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.multiselect--active .multiselect__select {
  transform: rotateZ(180deg);
}
.multiselect--above.multiselect--active .multiselect__current,
.multiselect--above.multiselect--active .multiselect__input,
.multiselect--above.multiselect--active .multiselect__tags {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.multiselect__input,
.multiselect__single {
  position: relative;
  display: inline-block;
  min-height: 20px;
  line-height: 20px;
  border: none;
  border-radius: 5px;
  background: #fff;
  padding: 0 0 0 5px;
  width: calc(100%);
  transition: border 0.1s ease;
  box-sizing: border-box;
  margin-bottom: 0px;
  vertical-align: top;
}
.multiselect__input::placeholder {
  color: #35495e;
}
.multiselect__tag ~ .multiselect__input,
.multiselect__tag ~ .multiselect__single {
  width: auto;
}
.multiselect__input:hover,
.multiselect__single:hover {
  border-color: #cfcfcf;
}
.multiselect__input:focus,
.multiselect__single:focus {
  border-color: #a8a8a8;
  outline: none;
}
.multiselect__single {
  padding-left: 5px;
  padding-top: 2px;
}
.multiselect__tags-wrap {
  display: inline;
}
.multiselect__tags {
  min-height: 50px;
  display: block;
  padding: 14px 40px 0 14px;
  border-radius: 5px;
  border: 1px solid #00002f;
  background: #fff;
  font-size: 14px;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #41b883;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}
.multiselect__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: initial;
  width: 22px;
  text-align: center;
  line-height: 22px;
  transition: all 0.2s ease;
  border-radius: 5px;
}
.multiselect__tag-icon:after {
  content: "×";
  color: #266d4d;
  font-size: 14px;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #369a6e;
}
.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
  color: white;
}
.multiselect__current {
  line-height: 16px;
  min-height: 50px;
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  padding: 8px 12px 0;
  padding-right: 30px;
  white-space: nowrap;
  margin: 0;
  text-decoration: none;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  cursor: pointer;
}
.multiselect__select {
  z-index: 1;
  line-height: 16px;
  display: block;
  position: absolute;
  box-sizing: border-box;
  width: 40px;
  height: 49px;
  right: 1px;
  top: 1px;
  padding: 4px 8px;
  margin: 0;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.multiselect__select:before {
  position: relative;
  right: 0;
  top: 65%;
  color: #999;
  margin-top: 4px;
  border-style: solid;
  border-width: 5px 5px 0 5px;
  border-color: #999999 transparent transparent transparent;
  content: "";
}
.multiselect__placeholder {
  color: #adadad;
  display: inline-block;
  padding-top: 2px;
  padding-left: 10px;
  margin-bottom: 4px;
}
.multiselect--active .multiselect__placeholder {
  display: none;
}
.multiselect__content-wrapper {
  position: absolute;
  display: block;
  background: #fff;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 50;
  -webkit-overflow-scrolling: touch;
}
.multiselect__content {
  list-style: none;
  display: inline-block;
  padding: 0;
  margin: 0;
  min-width: 100%;
  vertical-align: top;
}
.multiselect--above .multiselect__content-wrapper {
  bottom: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: none;
  border-top: 1px solid #e8e8e8;
}
.multiselect__content::webkit-scrollbar {
  display: none;
}
.multiselect__element {
  display: block;
}
.multiselect__option {
  display: block;
  padding: 12px;
  min-height: 50px;
  
  text-decoration: none;
  text-transform: none;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
}
.multiselect__option:after {
  top: 0;
  right: 0;
  position: absolute;
  line-height: 40px;
  padding-right: 12px;
  padding-left: 20px;
  font-size: 13px;
}
.multiselect__option--highlight {
  background: #41b883;
  outline: none;
  color: white;
}
.multiselect__option--highlight:after {
  content: attr(data-select);
  background: #41b883;
  color: white;
}
.multiselect__option--selected {
  background: #f3f3f3;
  color: #35495e;
  font-weight: bold;
}
.multiselect__option--selected:after {
  content: attr(data-selected);
  color: silver;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}
.multiselect__option--selected.multiselect__option--highlight:after {
  background: #ff6a6a;
  content: attr(data-deselect);
  color: #fff;
}
.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select {
  background: #ededed;
  color: #a6a6a6;
}
.multiselect__option--disabled {
  background: #ededed !important;
  color: #a6a6a6 !important;
  cursor: text;
  pointer-events: none;
}
.multiselect__option--group {
  background: #ededed;
  color: #35495e;
}
.multiselect__option--group.multiselect__option--highlight {
  background: #35495e;
  color: #fff;
}
.multiselect__option--group.multiselect__option--highlight:after {
  background: #35495e;
}
.multiselect__option--disabled.multiselect__option--highlight {
  background: #dedede;
}
.multiselect__option--group-selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}
.multiselect__option--group-selected.multiselect__option--highlight:after {
  background: #ff6a6a;
  content: attr(data-deselect);
  color: #fff;
}
.multiselect-enter-active,
.multiselect-leave-active {
  transition: all 0.15s ease;
}
.multiselect-enter,
.multiselect-leave-active {
  opacity: 0;
}
.multiselect__strong {
  margin-bottom: 8px;
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
}
*[dir="rtl"] .multiselect {
  text-align: right;
}
*[dir="rtl"] .multiselect__select {
  right: auto;
  left: 1px;
}
*[dir="rtl"] .multiselect__tags {
  padding: 8px 8px 0px 40px;
}
*[dir="rtl"] .multiselect__content {
  text-align: right;
}
*[dir="rtl"] .multiselect__option:after {
  right: auto;
  left: 0;
}
*[dir="rtl"] .multiselect__clear {
  right: auto;
  left: 12px;
}
*[dir="rtl"] .multiselect__spinner {
  right: auto;
  left: 1px;
}
@keyframes spinning {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(2turn);
  }
}

</style>
